import 'flatpickr';
import 'dateformat'

export default {
  init(selector, config) {

    // declared in setup.php
//    console.log('Course Duration: '+enrolmentinfo['course_duration']);
//    console.log('Current start date: '+enrolmentinfo['current_start_date']);

  },
  finalize() {

    const duration = enrolmentinfo['course_duration'];
    const current_start_date = enrolmentinfo['current_start_date'];

    $("#startDateCalendar").flatpickr({
      altInput: true,
      altFormat: "D J M Y",
      dateFormat: "Y-m-d",
      minDate: new Date().fp_incr(1),
      maxDate: new Date().fp_incr(60),
      defaultDate: current_start_date,

      onClose: function(selectedDates, dateStr, instance){

        const dateFormat = require('dateformat');
        const newDate = new Date(dateStr);
        const newEndDate = new Date(dateStr);
        newEndDate.setDate(newEndDate.getDate() + 7 * duration); // Add  days
        const startLater = dateFormat(newDate, "ddd d mmm yyyy");
        const endLater = dateFormat(newEndDate, "ddd d mmm yyyy");
        const endLaterInput = dateFormat(newEndDate, "yyyy-mm-dd");

        $( "span.start_date" ).html( startLater );
        $( "span.end_date" ).html( endLater );
        $('#endDateInput').val(endLaterInput);
        $( "span.start_date_display" ).html( startLater );
        $("#mainDateDiv").removeClass('d-none'); // BIZ-1154: Remove d-none class
        $("#startNowDisplay").show('slow');
        $("#listItemStartDate").show('slow');
        $("#listItemCompletionTime").show('slow');
      }
    });

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/online-course-edit-enrolment.js